import { post, formatError, showError, handleError } from './ajax'

export default {
  methods: {
    ajaxPost: post,
    formatError,
    showError,
    handleError,
  }
}



// WEBPACK FOOTER //
// ./src/util/mixins.js